import React from 'react';

import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import { ArrowForwardIosIcon } from '@/assets/icon/ArrowForwardIosIcon';
import searchStartImage from '@/assets/images/search-start.png';
import { SourceEvent } from '@/utils/analytics.util';

import {
  ArrowForwardStyle,
  SearchMultipleBox,
  SearchMultipleContainer,
  SearchMultipleImage,
  SearchMultipleText,
} from './MultiSearch.style';

interface MultiSearchProps {
  onSearchClick?: (sourceEvent?: SourceEvent.ICON | SourceEvent.MENU) => void;
}

const MultiSearch: React.FC<MultiSearchProps> = ({ onSearchClick }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const handlePress = (
    e: React.MouseEvent | React.TouchEvent,
    source: SourceEvent.ICON | SourceEvent.MENU
  ) => {
    e.preventDefault();
    onSearchClick?.(source);
  };

  const handleArrowPress = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onSearchClick?.(SourceEvent.MENU);
  };

  return (
    <SearchMultipleContainer
      elevation={0}
      onMouseDown={(e) => handlePress(e, SourceEvent.MENU)}
      onTouchStart={(e) => handlePress(e, SourceEvent.MENU)}
    >
      <SearchMultipleBox>
        <SearchMultipleImage
          src={searchStartImage.src}
          alt="search-start"
          // added default width and heigh
          width={16}
          height={16}
          loading="eager"
          fetchPriority="high"
          priority
        />
        <SearchMultipleText variant="h3">
          {t('search.multiSearchTitle')}
        </SearchMultipleText>
      </SearchMultipleBox>

      <SearchMultipleBox>
        <ArrowForwardIosIcon
          style={ArrowForwardStyle(theme)}
          onMouseDown={handleArrowPress}
          onTouchStart={handleArrowPress}
        />
      </SearchMultipleBox>
    </SearchMultipleContainer>
  );
};

export default MultiSearch;
